import { MutableRefObject } from "react";
import { useEffect } from "react"

export const useOnClickOutside = <RefType extends HTMLElement = HTMLElement>(ref: MutableRefObject<Optional<RefType>>, onOutsideClick: () => void) => {
  useEffect(() => {

    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && event.target && !ref.current.contains(event.target as Node | null)) {
        onOutsideClick();
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    }

  }, [ref, onOutsideClick]);
}
